import styled from 'styled-components';
import { Box, Button, Text } from '@rsos/components/capstone/base';
import {
  AccordionContentContainer,
  AccordionHeader,
  AccordionWrapper,
} from '@rsos/components/capstone/base/Accordion/Accordion.styles';
import { ButtonBase } from '@rsos/components/capstone/base/Button/Button.styles';

export const TF911Container = styled(Box)`
  border: ${({ theme }) => `1px solid ${theme.colors.lightLineDivider}`};
  border-radius: 5px;
  flex: 1 1 auto;
  transition: max-height 0.6s ease;
`;

export const HeaderContainer = styled(Box).attrs({
  position: 'relative',
  align: 'center',
  width: '100%',
  paddingTop: '12px',
  backgroundColor: 'background',
  borderRadius: '5px',
  overflowY: 'hidden', // Header of accordion is shown when expanded
})``;

export const ActionsBox = styled(Box).attrs({
  position: 'relative',
  horizontal: true,
  align: 'center',
  flex: '0 0 auto',
})``;

export const ActionButton = styled(Box).attrs(({ noMargin }) => ({
  align: 'center',
  justify: 'center',
  width: '24px',
  height: '24px',
  marginRight: noMargin ? 0 : '5px',
  backgroundColor: 'background',
  borderRadius: '5px',
}))`
  ${({ showBorder, theme }) =>
    showBorder && `border: 1px solid ${theme.colors.heavyLineOutline}`};
  transition: background-color 0.3s;
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => `${theme.colors.lightLineDivider}`};
  }
`;

// bottom left and bottom right
const TF911_BOTTOM_BORDER_RADIUS = `border-radius: 0 0 5px 5px;`;

// Adds styling to the Accordion components to accommodate design requirements
// in addition to dynamic height of available space in the call pane.
export const AccordionContainer = styled(Box)`
  height: 100%;
  ${AccordionWrapper} {
    height: 100%;
    ${TF911_BOTTOM_BORDER_RADIUS}

    ${AccordionHeader} {
      border-bottom: ${({ showBorder, theme }) =>
        showBorder ? `1px solid ${theme.colors.lightLineDivider}` : 'none'};
      ${({ showBorder }) =>
        !showBorder &&
        `${TF911_BOTTOM_BORDER_RADIUS}`} // accordion collapsed vs expanded state
      padding-bottom: 16px;
      ${Box}:last-child {
        /* target the last Box in AccordionHeader for the chevron button */
        ${ButtonBase} {
          border-radius: 0 5px 5px 0;
          margin: 0;
          margin-left: 2px;
        }
      }
    }
    ${AccordionContentContainer} {
      ${TF911_BOTTOM_BORDER_RADIUS}
    }
  }
`;

export const StartChatButton = styled(Button)`
  border-radius: 5px 0 0 5px;
`;

export const EndChatContainer = styled(Box)`
  height: 100%;
  margin-top: 8px;
  padding-bottom: 12px;
  width: 100%;
`;

export const EndChatButton = styled(Button)`
  border-radius: 5px;
`;

export const StartMessagesContainer = styled(Box)`
  ${TF911_BOTTOM_BORDER_RADIUS}
`;

export const StartMessageContainer = styled(Box)`
  &:hover {
    background-color: ${({ theme }) => `${theme.colors.lightLineDivider}`};
  }
`;

export const StartMessage = styled(Text).attrs({})`
  color: ${({ theme }) => theme.colors.secondaryText};
  font-size: 12px;
`;

export const RedCircle = styled(Box)`
  background-color: ${({ theme }) => `${theme.colors.lightDanger}`};
  border-radius: 10px;
  display: inline-flex;
  height: 8px;
  margin-right: 4px;
  width: 8px;
`;

export const ChatContainer = styled(Box)`
  border-top: ${({ showBorder, theme }) =>
    showBorder ? `1px solid ${theme.colors.lightLineDivider}` : 'none'};
`;
